var exports = {
  "Q": "x4ddf2309--7f8d06--content",
};

module.exports = exports;
